import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

import { notify } from '@/ui/snackbar/notify';
import { askToJoin } from '@/api/v4/user.api';

export const useAskToJoin = () => {
  const { t } = useTranslation('default');

  const mutation = useMutation({
    mutationFn: askToJoin,
    onError: () => {
      notify({
        message: t('unknownError'),
      });
    },
  });

  return {
    submitAskToJoin: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
};
